import { createSlice } from "@reduxjs/toolkit";

export const toolSelectSlice = createSlice({
    name: "toolSelect",
    initialState: {
        tool: "pan",
        sideBarTab: 0,
        sideBarOpen: false,
        drawTool: "Point",
        measureTool: undefined,
        measureAreaUnits: "Feet \xB2",
        measureDistanceUnits: "Feet",
        bearingToggle: false,
        streetView: false,
        disclaimerOpen: true,
        aboutWinOpen: false,
        printBox: undefined,
        dataGrid: false,
        horizontalView: false,
        authChange: false,
    },
    reducers: {
        setActiveTool: (state, action) => {
            state.tool = action.payload;
        },
        setActiveSideBarTab: (state, action) => {
            state.sideBarTab = action.payload;
        },
        setSideBarOpen: (state, action) => {
            state.sideBarOpen = action.payload;
        },
        setDrawTool: (state, action) => {
            state.drawTool = action.payload;
        },
        setMeasureTool: (state, action) => {
            state.measureTool = action.payload;
        },
        setMeasureAreaUnits: (state, action) => {
            state.measureAreaUnits = action.payload;
        },
        setMeasureDistanceUnits: (state, action) => {
            state.measureDistanceUnits = action.payload;
        },
        setBearingToggle: (state, action) => {
            state.bearingToggle = action.payload;
        },
        setStreetView: (state, action) => {
            state.streetView = action.payload;
        },
        setDisclaimerOpen: (state, action) => {
            state.disclaimerOpen = action.payload;
        },
        setAboutWinOpen: (state, action) => {
            state.aboutWinOpen = action.payload;
        },
        setPrintBox: (state, action) => {
            state.printBox = action.payload;
        },
        setDataGrid: (state, action) => {
            state.dataGrid = action.payload;
        },
        setHorizontalView: (state, action) => {
            state.horizontalView = action.payload;
        },
        setAuthChange: (state, action) => {
            state.authChange = action.payload;
        },
    },
});

export const {
    setActiveTool,
    setActiveSideBarTab,
    setSideBarOpen,
    setDrawTool,
    setStreetView,
    setDisclaimerOpen,
    setAboutWinOpen,
    setPrintBox,
    setMeasureTool,
    setMeasureAreaUnits,
    setMeasureDistanceUnits,
    setBearingToggle,
    setDataGrid,
    setHorizontalView,
    setAuthChange,
} = toolSelectSlice.actions;

export default toolSelectSlice.reducer;
